<template>
  <div
    v-if="entries && entries.length"
    :class="$style.root"
  >
    <pages-editions-slug-parent-titles-carousel-component
      :initial-slide="initialSlideIndex"
      ref="carouselTarget"
    >
      <SwiperSlide
        v-for="(entry, index) in entries"
        :key="entry?.id"
        :class="$style.slide"
      >
        <pages-editions-slug-parent-titles-thumbnail-component
          :data="entry"
          :active="editionIndex === entry?.editionIndex"
        />
      </SwiperSlide>
    </pages-editions-slug-parent-titles-carousel-component>
  </div>
</template>

<script lang="ts" setup>
import { SwiperSlide } from 'swiper/vue'

const route = useRoute()
const router = useRouter()
const localePath = useLocalePath()

const carouselTarget = ref(null)

const props = defineProps({
  entries: {
    type: Array
  },
  editionIndex: Number
})

const initialSlideIndex = props?.entries?.findIndex(slide => slide?.slug === route.params.slug) || 0

const currentSlideIndex = computed(() => {
  return carouselTarget.value?.swiperInstance?.activeIndex
})

watch(currentSlideIndex, (value) => {
  if (getRouteName()?.startsWith('editions') == false) return

  const entry = props?.entries[value]

  const routeName = getRouteName() === 'editions' ? 'editions-slug-index-about' : getRouteName()

  if (!entry?.slug || entry?.slug !== route.params.slug) {
    router.push(localePath({
      name: routeName,
      params: { slug: entry?.slug }
    }))
  }
})

// NOTE This is a workaround for the issue where the carousel doesn't slide to the correct index on page load
const resolver = () => new Promise(r => setTimeout(() => r(), 150));

onBeforeRouteUpdate(async (to, from, next) => {
  if (to?.name?.startsWith('editions-slug-index') && from?.params?.slug !== to?.params?.slug) {
    const index = props?.entries?.findIndex(slide => slide?.slug === to.params.slug)
    if (index !== -1) {
      carouselTarget.value?.swiperInstance?.slideTo(index)
    }

    await resolver()
    next()
  } else {
    next()
  }
})
</script>

<style module>
.root {
  user-select: none;
}

.slide:global(.swiper-slide) {
  max-width: calc(100vw - var(--unit--horizontal) * 2);
  width: calc(var(--width--container) - (var(--unit--horizontal) * 1));
}
</style>
